import React from "react";

import {
    Typography,
    LinearProgress,
    Box,
} from "@mui/material";
import { withStyles } from '@/compat/muiStyles';


const BorderLinearProgress = withStyles((theme) => ({
    root: {
        height: 10,
        borderRadius: 5,
    },
    colorPrimary: {
        backgroundColor: theme.palette.secondary.mainOpaque,
    },
    bar: {
        borderRadius: 5,
        backgroundColor: theme.palette.secondary.main,
    },
}))(LinearProgress);

const LinearProgressWithLabel = props => {
    // Coerce to a number (default 0) so the determinate LinearProgress always has
    // a value (MUI warns otherwise) and the label never shows "NaN%".
    const value = Math.min(100, Number(props.value) || 0);
    const newProps = { ...props, value };

    return (
        <Box display="flex" alignItems="center">
            <Box width="100%" mr={1}>
                <BorderLinearProgress variant="determinate" {...newProps} />
            </Box>
            <Box minWidth={35}>
                <Typography variant="body2" color="textSecondary">{`${Math.round(value)}%`}</Typography>
            </Box>
        </Box>
    );
}

export default LinearProgressWithLabel;